"use strict";

class SalesApplicationAddSaleSUVController {

  constructor($scope, $window, $filter, SSAppService, SSHttpService, SSUtilService, SSDateService, SSAlertService, $timeout, SSConfigService, SSConfirmationService, SSEoiService) {
    const self = this;

    self.$scope = $scope;
    self.$window = $window;
    self.SSAppService = SSAppService;
    self.SSHttpService = SSHttpService;
    self.SSUtilService = SSUtilService;
    self.SSDateService = SSDateService;
    self.SSAlertService = SSAlertService;
    self.$timeout = $timeout;
    self.SSConfigService = SSConfigService;
    self.SSConfirmationService = SSConfirmationService;
    self.SSEoiService = SSEoiService;
    self.data = SHOWSUITE.data;
    self.filter = $filter;

    self.init();
  }

  init() {
    const self = this;

    self.nric_type = 'NRIC';
    self.passport_type = 'Passport No';
    self.company_reg_type = 'Company Registration No';

    self.buyer = null;
    self.buyer_found = false;
    self.buyer_not_found = false;
    self.authorize_code = '542457';
    self.fieldChanged('individual_national_id');
    self.search_by = self.nric_type;
  }

  fieldChanged(field){
    const self = this;

    self.input_error = '';
    self.input_value = '';
    self.input_value_phone = '';
    self.input_field = field;
  }

  getBuyerProfile() {
    const self = this;

    if(self.input_value == ''){
      self.input_error = '';
      self.input_error = "Please enter " + self.search_by;
      return;
    }

    if (self.search_by === self.nric_type && !self.SSUtilService.validateSGNRIC(self.input_value)) {
      self.SSAlertService.danger("Error!", "Please enter a valid NRIC");
      return;
    }

    self.buyer = null;
    self.SSAlertService.message = null

    let url = 'sec/buyers/search';
    let params = {
        'filter_field': self.input_field,
        'filter_value': self.input_value,
        'include': 'brokers, buyers, instruments'
    };

    self.buyer_found = false;
    self.buyer_not_found = false;

    loading(true);
    self.SSHttpService.getAPIRequest(url, params).then(function (response) {
      loading(false);
      if (response instanceof Error) {
          self.SSAlertService.parseAndDisplayError(response);
          return;
      }

      self.disableProceed = false;

      if(response.hasOwnProperty("data")){        
        self.buyer_found = true;
        self.buyer = response.data.buyer;
        return;
      }
      self.buyer_not_found = true;
    });
  }

}

SalesApplicationAddSaleSUVController.$inject = ['$scope', '$window', '$filter', 'SSAppService', 'SSHttpService', 'SSUtilService', 'SSDateService', 'SSAlertService', '$timeout', 'SSConfigService', 'SSConfirmationService', 'SSEoiService'];
app.controller('SalesApplicationAddSaleSUVController', SalesApplicationAddSaleSUVController);